// UAcsLogin
export const HAS_USER_INFO = "HAS_USER_INFO"
export const GET_USER_INFO = "GET_USER_INFO"
export const GET_USER_ID = "GET_USER_ID"
export const GET_IS_ADMINISTRATOR = "GET_IS_ADMINISTRATOR"
export const GET_JWT_TOKEN = "GET_JWT_TOKEN"
export const HAS_JWT_TOKEN = "HAS_JWT_TOKEN"
export const GET_FORM_USER_NAME = "GET_FORM_USER_NAME"
export const GET_FORM_USER_PASS = "GET_FORM_USER_PASS"
export const GET_FORM_CHECKED = "GET_FORM_CHECKED"
export const HAS_ROLE_FN = "HAS_ROLE_FN"
export const IS_MINIMATCH_ANY_FN = "IS_MINIMATCH_ANY_FN"
export const GET_DASHBOARD_TOTAL_VENUE = "GET_DASHBOARD_TOTAL_VENUE"
export const GET_DASHBOARD_TOTAL_BOX = "GET_DASHBOARD_TOTAL_BOX"
export const GET_DASHBOARD_TOTAL_ONLINE_BOX = "GET_DASHBOARD_TOTAL_ONLINE_BOX"
export const GET_DASHBOARD_TOTAL_OFFLINE_BOX = "GET_DASHBOARD_TOTAL_OFFLINE_BOX"
export const GET_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX =
    "GET_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX"
export const GET_MARKET_TOTAL_VENUE_FN = "GET_MARKET_TOTAL_VENUE_FN"
export const GET_MARKET_TOTAL_BOX_FN = "GET_MARKET_TOTAL_BOX_FN"
export const GET_MARKET_TOTAL_ONLINE_BOX_FN = "GET_MARKET_TOTAL_ONLINE_BOX_FN"
export const GET_MARKET_TOTAL_OFFLINE_BOX_FN = "GET_MARKET_TOTAL_OFFLINE_BOX_FN"
export const GET_MARKET_TOTAL_UPDATE_REQUIRED_BOX_FN =
    "GET_MARKET_TOTAL_UPDATE_REQUIRED_BOX_FN"
export const GET_VENUE_TOTAL_BOX_FN = "GET_VENUE_TOTAL_BOX_FN"
export const GET_VENUE_TOTAL_ONLINE_BOX_FN = "GET_VENUE_TOTAL_ONLINE_BOX_FN"
export const GET_VENUE_TOTAL_OFFLINE_BOX_FN = "GET_VENUE_TOTAL_OFFLINE_BOX_FN"
export const GET_VENUE_TOTAL_UPDATE_REQUIRED_BOX_FN =
    "GET_VENUE_TOTAL_UPDATE_REQUIRED_BOX_FN"
export const GET_MAPBOX_STYLES_ID = "GET_MAPBOX_STYLES_ID"
export const GET_IS_RESTARTING = "GET_IS_RESTARTING"

// Socket module
export const SOCKET_ISCONNECTED = "SOCKET_ISCONNECTED"
export const SOCKET_ISSUBSCRIBED = "SOCKET_ISSUBSCRIBED"
export const GET_$SOCKET = "GET_$SOCKET"
export const HAS_$SOCKET = "HAS_$SOCKET"
export const SOCKET_IS_DISPATCHER_CONNECTED = "SOCKET_IS_DISPATCHER_CONNECTED"

// Router module
// vuex-router-sync
export const GET_CURRENT_ROUTE = "GET_CURRENT_ROUTE"

// Company module
export const GET_COMPANY_LIST = "GET_COMPANY_LIST"

// Country module
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST"

// Market module
export const GET_MARKET_LIST = "GET_MARKET_LIST"
export const GET_MARKET_BY_ID = "GET_MARKET_BY_ID"
export const HAS_SELECTED_MARKET = "HAS_SELECTED_MARKET"
export const GET_SELECTED_MARKET_ID = "GET_SELECTED_MARKET_ID"
export const GET_SELECTED_MARKET = "GET_SELECTED_MARKET"
export const GET_SELECTED_MARKET_TOTAL_VENUE = "GET_SELECTED_MARKET_TOTAL_VENUE"
export const GET_SELECTED_MARKET_TOTAL_BOX = "GET_SELECTED_MARKET_TOTAL_BOX"
export const GET_SELECTED_MARKET_TOTAL_ONLINE_BOX =
    "GET_SELECTED_MARKET_TOTAL_ONLINE_BOX"
export const GET_SELECTED_MARKET_TOTAL_OFFLINE_BOX =
    "GET_SELECTED_MARKET_TOTAL_OFFLINE_BOX"
export const GET_SELECTED_MARKET_TOTAL_UPDATE_REQUIRED_BOX =
    "GET_SELECTED_MARKET_TOTAL_UPDATE_REQUIRED_BOX"

// Venue module
export const GET_VENUE_LIST = "GET_VENUE_LIST"
export const GET_SELECTED_VENUE = "GET_SELECTED_VENUE"
export const GET_VENUE_BY_ID = "GET_VENUE_BY_ID"
export const GET_SELECTED_VENUE_MARKET_ID = "GET_SELECTED_VENUE_MARKET_ID"
export const GET_SELECTED_VENUE_ID = "GET_SELECTED_VENUE_ID"
export const GET_UNSELECTED_VENUE_LIST = "GET_UNSELECTED_VENUE_LIST"
export const HAS_SELECTED_VENUE = "HAS_SELECTED_VENUE"
export const GET_SELECTED_VENUE_TOTAL_BOX = "GET_SELECTED_VENUE_TOTAL_BOX"
export const GET_SELECTED_VENUE_TOTAL_ONLINE_BOX =
    "GET_SELECTED_VENUE_TOTAL_ONLINE_BOX"
export const GET_SELECTED_VENUE_TOTAL_OFFLINE_BOX =
    "GET_SELECTED_VENUE_TOTAL_OFFLINE_BOX"
export const GET_SELECTED_VENUE_TOTAL_UPDATE_REQUIRED_BOX =
    "GET_SELECTED_VENUE_TOTAL_UPDATE_REQUIRED_BOX"

// SmartBox module
export const GET_FILTERED_SMART_BOX_LIST = "GET_FILTERED_SMART_BOX_LIST"
export const GET_SMART_BOX_LIST = "GET_SMART_BOX_LIST"
export const GET_SELECTED_SMART_BOX_LIST = "GET_SELECTED_SMART_BOX_LIST"
export const GET_SELECTED_SMART_BOX_MAC_ADDRESS_LIST =
    "GET_SELECTED_SMART_BOX_MAC_ADDRESS_LIST"
export const HAS_SELECTED_SMART_BOX = "HAS_SELECTED_SMART_BOX"
export const GET_OPERATION_LOG_LIST = "GET_OPERATION_LOG_LIST"
export const GET_IS_SEARCH_MODE = "GET_IS_SEARCH_MODE"
export const GET_IS_FUZZY_SEARCH = "GET_IS_FUZZY_SEARCH"
export const GET_IS_ACCURATE_SEARCH = "GET_IS_ACCURATE_SEARCH"
export const GET_FUZZY_SEARCH_PARAMETER = "GET_FUZZY_SEARCH_PARAMETER"

// Version module
export const GET_GATEWAY_VERSION_LIST = "GET_GATEWAY_VERSION_LIST"
export const GET_SBLDRIVE_VERSION_LIST = "GET_SBLDRIVE_VERSION_LIST"
